import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { LocalStorageService } from '@recruitee/common';

import { FeatureFlagsHttpService } from './store/feature-flags-http.service';
import { FeatureFlag } from './types';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  public static readonly FEATURE_CACHE_KEY: string = 'feature_flags';

  constructor(
    private featureFlagsHttpService: FeatureFlagsHttpService,
    private localStorageService: LocalStorageService,
  ) {}

  public loadFeatureFlags() {
    return this.featureFlagsHttpService.loadFeatureFlagsList().pipe(map(data => data.features));
  }

  public getFromLocalStorage(): FeatureFlag[] {
    return this.localStorageService.get(FeatureFlagsService.FEATURE_CACHE_KEY) || [];
  }

  public saveInLocalStorage(flags: FeatureFlag[]) {
    this.localStorageService.set(FeatureFlagsService.FEATURE_CACHE_KEY, flags);
  }
}
